import SnackbarStore from "./SnackbarStore";

export default class UiStore {
  snackbar = new SnackbarStore(this);
}
